(function () {
  var STORAGE_PREFIX = "vaku_pdp_ab_assignment:";
  var INCLUDED_PREFIX = "vaku_pdp_ab_included:";
  var EVENT_PREFIX = "vaku_pdp_ab_";
  var ASSIGNMENT_TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var CART_ATTRIBUTE_TIMEOUT_MS = 5000;
  var context = window.VakuPdpExperimentContext;
  var currentAssignment = null;
  var currentAssignmentForced = false;

  function normalizeForcedPreviewParam() {
    if (!window.URLSearchParams || !window.history || !window.history.replaceState) {
      return;
    }

    var parameters = new URLSearchParams(window.location.search);
    var legacyForcedVariant = parameters.get("pdp_ab_variant");
    if (!legacyForcedVariant) {
      return;
    }

    parameters.delete("pdp_ab_variant");
    parameters.set("pdp_ab_force", legacyForcedVariant);
    var query = parameters.toString();
    window.history.replaceState(
      window.history.state,
      document.title,
      window.location.pathname + (query ? "?" + query : "") + window.location.hash
    );
  }

  normalizeForcedPreviewParam();

  if (!context || (!context.registry && !context.registryUrl) || !context.product) {
    return;
  }

  function onReady(callback) {
    if (document.readyState === "loading" || (window.VakuPdpExperimentInit && !window.VakuPdpExperimentInit.domReady)) {
      document.addEventListener("DOMContentLoaded", callback);
      return;
    }
    callback();
  }

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      return false;
    }
    return true;
  }

  function normalizeAssignment(record, variant) {
    var assignedAt = record.assignedAt || record.firstSeenAt || new Date().toISOString();
    return {
      variantId: variant.id,
      assignedAt: assignedAt
    };
  }

  function assignmentExpired(record) {
    var firstSeen = Date.parse(record.firstSeenAt || record.assignedAt || "");
    return !isNaN(firstSeen) && Date.now() - firstSeen >= ASSIGNMENT_TTL_MS;
  }

  function lower(value) {
    return String(value || "").toLowerCase();
  }

  function arrayValue(value) {
    return Object.prototype.toString.call(value) === "[object Array]" ? value : [];
  }

  function containsValue(values, value) {
    var needle = lower(value);
    for (var i = 0; i < values.length; i += 1) {
      if (lower(values[i]) === needle) {
        return true;
      }
    }
    return false;
  }

  function intersects(values, candidates) {
    for (var i = 0; i < values.length; i += 1) {
      if (containsValue(candidates, values[i])) {
        return true;
      }
    }
    return false;
  }

  function loadRegistry(url, callback) {
    if (window.fetch) {
      window.fetch(url, { cache: "no-store", credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("registry_load_failed");
          }
          return response.json();
        })
        .then(function (registry) {
          callback(null, registry);
        })
        .catch(function (error) {
          callback(error);
        });
      return;
    }

    var request = new XMLHttpRequest();
    request.open("GET", url, true);
    request.onreadystatechange = function () {
      if (request.readyState !== 4) {
        return;
      }
      if (request.status < 200 || request.status >= 300) {
        callback(new Error("registry_load_failed"));
        return;
      }
      try {
        callback(null, JSON.parse(request.responseText));
      } catch (error) {
        callback(error);
      }
    };
    request.send();
  }

  function templateKeys() {
    var name = context.template && context.template.name ? context.template.name : "product";
    var suffix = context.template && context.template.suffix ? context.template.suffix : "";
    var keys = [name];
    if (suffix) {
      keys.push(name + "." + suffix);
    }
    return keys;
  }

  function viewportWidth() {
    return window.innerWidth || document.documentElement.clientWidth || 0;
  }

  function matchesScope(experiment) {
    var scope = experiment.scope || {};
    var product = context.product || {};
    var templates = arrayValue(scope.templates);
    var handles = arrayValue(scope.handles);
    var excludeHandles = arrayValue(scope.excludeHandles);
    var productTypes = arrayValue(scope.productTypes);
    var vendors = arrayValue(scope.vendors);
    var tags = arrayValue(scope.tags);
    var maxViewportWidth = Number(scope.maxViewportWidth || 0);

    if (excludeHandles.length && containsValue(excludeHandles, product.handle)) {
      return false;
    }
    if (handles.length && !containsValue(handles, product.handle)) {
      return false;
    }
    if (productTypes.length && !containsValue(productTypes, product.type)) {
      return false;
    }
    if (vendors.length && !containsValue(vendors, product.vendor)) {
      return false;
    }
    if (tags.length && !intersects(tags, arrayValue(product.tags))) {
      return false;
    }
    if (templates.length && !intersects(templateKeys(), templates)) {
      return false;
    }
    if (scope.requiresCouponCode) {
      var couponInput = document.getElementById("coupon-input");
      if (!document.getElementById("coupon-apply-btn") || !couponInput ||
          !String(couponInput.value || "").trim()) {
        return false;
      }
    }
    if (maxViewportWidth > 0 && viewportWidth() > maxViewportWidth) {
      return false;
    }
    if (scope.requiresGalleryThumbnails && !document.querySelector("#smallGallery [data-item-type]")) return false;
    return true;
  }

  function activeExperiment(registry) {
    var experiments = arrayValue(registry && registry.experiments);
    var activeId = registry && registry.activeExperimentId;
    var fallback = null;

    for (var i = 0; i < experiments.length; i += 1) {
      // Draft candidates are reachable only by explicit forced preview on an unpublished theme.
      var forcedDraft = context.preview && experiments[i].status === "draft" &&
        findVariant(experiments[i], queryParam("pdp_ab_force"));
      if ((experiments[i].status !== "running" && !forcedDraft) || !matchesScope(experiments[i])) {
        continue;
      }
      if (experiments[i].id === activeId) {
        return experiments[i];
      }
      if (!fallback) {
        fallback = experiments[i];
      }
    }
    return fallback;
  }

  function queryParam(name) {
    var match = new RegExp("[?&]" + name + "=([^&]+)").exec(window.location.search);
    return match ? decodeURIComponent(match[1].replace(/\+/g, " ")) : "";
  }

  function findVariant(experiment, variantId) {
    var variants = arrayValue(experiment.variants);
    for (var i = 0; i < variants.length; i += 1) {
      if (variants[i].id === variantId) {
        return variants[i];
      }
    }
    return null;
  }

  function experimentStorageKey(experiment) {
    return STORAGE_PREFIX + experiment.id;
  }

  function legacyProductStorageKey(experiment) {
    return STORAGE_PREFIX + experiment.id + ":" + context.product.handle;
  }

  function experimentIncludedKey(experiment) {
    return INCLUDED_PREFIX + experiment.id;
  }

  function legacyProductIncludedKey(experiment) {
    return INCLUDED_PREFIX + experiment.id + ":" + context.product.handle;
  }

  function trafficIncluded(experiment) {
    var traffic = typeof experiment.traffic === "number" ? experiment.traffic : 100;
    if (traffic >= 100) {
      return true;
    }
    if (traffic <= 0) {
      return false;
    }

    var key = experimentIncludedKey(experiment);
    var stored = readStorage(key);
    if (stored !== "1" && stored !== "0") {
      stored = readStorage(legacyProductIncludedKey(experiment));
      if (stored === "1" || stored === "0") {
        writeStorage(key, stored);
      }
    }
    if (stored === "1") {
      return true;
    }
    if (stored === "0") {
      return false;
    }

    var included = Math.random() * 100 < traffic;
    writeStorage(key, included ? "1" : "0");
    return included;
  }

  function chooseWeightedVariant(experiment) {
    var variants = arrayValue(experiment.variants);
    var totalWeight = 0;
    var i;

    for (i = 0; i < variants.length; i += 1) {
      totalWeight += Number(variants[i].weight || 0);
    }
    if (!variants.length || totalWeight <= 0) {
      return null;
    }

    var selected = Math.random() * totalWeight;
    var running = 0;
    for (i = 0; i < variants.length; i += 1) {
      running += Number(variants[i].weight || 0);
      if (selected <= running) {
        return variants[i];
      }
    }
    return variants[0];
  }

  function storedVariant(experiment) {
    var key = experimentStorageKey(experiment);
    var stored = readStorage(key) || readStorage(legacyProductStorageKey(experiment));
    var parsed;
    if (!stored) {
      return null;
    }

    try {
      parsed = JSON.parse(stored);
    } catch (error) {
      writeStorage(key, "");
      return null;
    }

    if (assignmentExpired(parsed)) {
      writeStorage(key, "");
      return null;
    }

    var variant = findVariant(experiment, parsed.variantId);
    if (variant && Number(variant.weight || 0) > 0) {
      currentAssignment = normalizeAssignment(parsed, variant);
      writeStorage(key, JSON.stringify(currentAssignment));
      return variant;
    }
    return null;
  }

  function storeVariant(experiment, variant) {
    currentAssignment = normalizeAssignment({}, variant);
    writeStorage(experimentStorageKey(experiment), JSON.stringify(currentAssignment));
  }

  function assignedVariant(experiment) {
    var forced = queryParam("pdp_ab_force");
    var forcedVariant = forced ? findVariant(experiment, forced) : null;
    // Retired preview links show control but remain excluded from production.
    if (forcedVariant && Number(forcedVariant.weight || 0) <= 0) {
      forcedVariant = findVariant(experiment, "control");
    }
    if (forcedVariant) {
      currentAssignmentForced = true;
      currentAssignment = normalizeAssignment({}, forcedVariant);
      return forcedVariant;
    }
    currentAssignmentForced = false;

    if (!trafficIncluded(experiment)) {
      return null;
    }

    var persistedVariant = storedVariant(experiment);
    if (persistedVariant) {
      return persistedVariant;
    }

    var variant = chooseWeightedVariant(experiment);
    if (variant) {
      storeVariant(experiment, variant);
    }
    return variant;
  }

  function addClass(element, className) {
    if (!element || !className) {
      return;
    }
    var classes = String(className).split(/\s+/);
    for (var i = 0; i < classes.length; i += 1) {
      if (!classes[i]) {
        continue;
      }
      if (element.classList) {
        element.classList.add(classes[i]);
      } else if ((" " + element.className + " ").indexOf(" " + classes[i] + " ") === -1) {
        element.className += " " + classes[i];
      }
    }
  }

  function productRoot() {
    return document.querySelector(".product_page_template") || document.body;
  }

  function purchaseRoot() {
    return productRoot().querySelector(".tt-product-single-info") || productRoot();
  }

  function productForms() {
    var forms = purchaseRoot().querySelectorAll('form[action*="/cart/add"]');
    var result = [];
    for (var i = 0; i < forms.length; i += 1) {
      if (forms[i].querySelector('[name="id"]')) {
        result.push(forms[i]);
      }
    }
    return result;
  }

  function attributionMarkers(experiment, variant) {
    var markers = {
      pdp_ab_experiment: experiment.id,
      pdp_ab_variant: variant.id
    };
    if (currentAssignmentForced) {
      markers.pdp_ab_forced = "1";
    }
    return markers;
  }

  function updateCartAttributes(experiment, variant, callback) {
    var markers = attributionMarkers(experiment, variant);
    if (!markers.pdp_ab_forced) {
      markers.pdp_ab_forced = "";
    }
    var finished = false;
    var timeout = window.setTimeout(function () {
      finish();
    }, CART_ATTRIBUTE_TIMEOUT_MS);
    var finish = function (cart) {
      if (finished) {
        return;
      }
      finished = true;
      window.clearTimeout(timeout);
      if (typeof callback === "function") {
        callback(cart || null);
      }
    };

    if (window.fetch) {
      window.fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        keepalive: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ attributes: markers })
      }).then(function (response) {
        if (!response.ok) {
          throw new Error("cart_attribute_update_failed");
        }
        return response.json();
      }).then(function (cart) {
        finish(cart);
      }).catch(function () {
        finish();
      });
      return;
    }

    if (window.Shopify && typeof window.Shopify.updateCartAttributes === "function") {
      window.Shopify.updateCartAttributes(markers, finish);
      return;
    }
    finish();
  }

  function resumeProductForm(form, submitter) {
    form.setAttribute("data-pdp-ab-attribution-ready", "1");
    if (typeof form.requestSubmit === "function") {
      try {
        if (submitter) {
          form.requestSubmit(submitter);
        } else {
          form.requestSubmit();
        }
        return;
      } catch (error) {}
    }
    form.removeAttribute("data-pdp-ab-attribution-ready");
    window.HTMLFormElement.prototype.submit.call(form);
  }

  function selectedPurchase(experiment, variant) {
    var form = productForms()[0];
    var idInput = form && form.querySelector('[name="id"]');
    var quantityInput = form && form.querySelector('[name="quantity"]');
    var quantity = parseInt(quantityInput && quantityInput.value, 10);
    var lineAttributes = {};
    if (form && window.FormData) {
      new FormData(form).forEach(function (value, name) {
        var match = /^properties\[([^\]]+)\]$/.exec(name);
        if (match && !/^_?pdp_ab_/.test(match[1])) {
          lineAttributes[match[1]] = String(value);
        }
      });
    }
    return {
      variantId: idInput ? String(idInput.value) : "",
      quantity: !isNaN(quantity) && quantity > 0 ? quantity : 1,
      cartAttributes: attributionMarkers(experiment, variant),
      lineAttributes: lineAttributes
    };
  }

  function fastrrProductButton() {
    return purchaseRoot().querySelector('.shiprocket-headless[data-type="product"] .sr-headless-checkout');
  }

  function nativeProductButton() {
    return purchaseRoot().querySelector(".buyinoneclick .shopify-payment-button__button");
  }

  // Selects the active regional checkout.
  function stickyProductButton() {
    if (window.vakuShiprocketCheckoutEnabled === true) {
      return fastrrProductButton();
    }
    return nativeProductButton();
  }

  function fastrrDirectReady() {
    return Boolean(
      fastrrProductButton() &&
      window.shiprocketCheckoutEvents &&
      typeof window.shiprocketCheckoutEvents.buyDirect === "function"
    );
  }

  // The SDK carries this URL to its native checkout redirect. Keep order-level
  // attribution on the cart permalink even when direct checkout never wrote a cart.
  function fastrrFallbackUrl(purchase, couponCode) {
    var url = window.location.protocol + "//" + window.location.host + "/cart/" +
      encodeURIComponent(purchase.variantId) + ":" + purchase.quantity;
    var params = [];
    var markers = purchase.cartAttributes;
    for (var key in markers) {
      if (Object.prototype.hasOwnProperty.call(markers, key)) {
        params.push(encodeURIComponent("attributes[" + key + "]") + "=" + encodeURIComponent(markers[key]));
      }
    }
    if (!markers.pdp_ab_forced) params.push(encodeURIComponent("attributes[pdp_ab_forced]") + "=");
    if (couponCode) params.push("discount=" + encodeURIComponent(couponCode));
    return url + "?" + params.join("&");
  }

  function startFastrrBuyNow(button, experiment, variant) {
    var purchase = selectedPurchase(experiment, variant);
    var attempts = 0;
    button.disabled = true;
    emit("buy_now_intent", experiment, variant);

    function openFastrr() {
      if (!fastrrDirectReady()) {
        if (attempts < 20) {
          attempts += 1;
          window.setTimeout(openFastrr, 100);
          return;
        }
        button.disabled = false;
        return;
      }

      var couponCode = readStorage("fastrrCouponCode") || null;
      try {
        window.shiprocketCheckoutEvents.buyDirect({
          type: "product",
          products: [{
            variantId: Number(purchase.variantId),
            quantity: purchase.quantity,
            customAttributes: purchase.lineAttributes
          }],
          cartAttributes: purchase.cartAttributes,
          fallbackUrl: fastrrFallbackUrl(purchase, couponCode),
          couponCode: couponCode,
          eventCallback: function () {
            button.disabled = false;
          }
        });
      } catch (error) {
        button.disabled = false;
      }
    }

    openFastrr();
  }

  function bindFastrrBuyNow(experiment, variant) {
    var root = purchaseRoot();

    root.addEventListener("click", function (event) {
      if (window.vakuShiprocketCheckoutEnabled !== true) {
        return;
      }
      var target = event.target;
      var button = fastrrProductButton();
      while (target && target !== root && target !== button) {
        target = target.parentNode;
      }
      if (!button || target !== button) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
      startFastrrBuyNow(button, experiment, variant);
    }, true);
  }

  // An existing exposed visitor can buy after leaving the enrollment scope.
  // Read canonical cart markers only on an explicit out-of-scope Fastrr click;
  // never assign, expose, restyle, or persist a new visitor here.
  function bindFastrrCartCarryover(registry) {
    var active = null;
    var experiments = arrayValue(registry && registry.experiments);
    for (var i = 0; i < experiments.length; i += 1) {
      if (experiments[i].id === registry.activeExperimentId &&
          (experiments[i].status === "running" || (context.preview && experiments[i].status === "draft"))) active = experiments[i];
    }
    if (!active || !window.fetch) return;
    var root = purchaseRoot();
    root.addEventListener("click", function (event) {
      var button = fastrrProductButton();
      if (window.vakuShiprocketCheckoutEnabled !== true || !button || !button.contains(event.target)) return;
      if (button.getAttribute("data-pdp-ab-carryover-ready") === "1") {
        button.removeAttribute("data-pdp-ab-carryover-ready");
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (button.getAttribute("data-pdp-ab-carryover-pending") === "1") return;
      button.setAttribute("data-pdp-ab-carryover-pending", "1");
      var completed = false;
      var timeout = window.setTimeout(replay, CART_ATTRIBUTE_TIMEOUT_MS);
      function replay() {
        if (completed) return;
        completed = true;
        window.clearTimeout(timeout);
        button.removeAttribute("data-pdp-ab-carryover-pending");
        button.setAttribute("data-pdp-ab-carryover-ready", "1");
        button.click();
      }
      window.fetch("/cart.js", {credentials: "same-origin", headers: {Accept: "application/json"}}).then(function (response) {
        if (!response.ok) throw new Error("cart_marker_read_failed");
        return response.json();
      }).then(function (cart) {
        if (completed) return;
        var markers = cart.attributes || {};
        var variant = markers.pdp_ab_experiment === active.id && findVariant(active, markers.pdp_ab_variant);
        if (!variant) return replay();
        completed = true;
        window.clearTimeout(timeout);
        button.removeAttribute("data-pdp-ab-carryover-pending");
        currentAssignmentForced = markers.pdp_ab_forced === "1";
        startFastrrBuyNow(button, active, variant);
      }).catch(replay);
    }, true);
  }

  function bindNativeBuyNow(experiment, variant) {
    var root = purchaseRoot();
    root.addEventListener("click", function (event) {
      var button = nativeProductButton();
      var target = event.target;
      while (target && target !== root && target !== button) target = target.parentNode;
      if (!button || target !== button) return;
      if (button.getAttribute("data-pdp-ab-attribution-ready") === "1") {
        button.removeAttribute("data-pdp-ab-attribution-ready");
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (button.getAttribute("data-pdp-ab-attribution-pending") === "1") return;
      button.setAttribute("data-pdp-ab-attribution-pending", "1");
      emit("buy_now_intent", experiment, variant);
      updateCartAttributes(experiment, variant, function () {
        button.removeAttribute("data-pdp-ab-attribution-pending");
        button.setAttribute("data-pdp-ab-attribution-ready", "1");
        button.click();
      });
    }, true);
  }

  function emit(name, experiment, variant, extra) {
    var markers = attributionMarkers(experiment, variant);
    var payload = {
      event: EVENT_PREFIX + name,
      experiment_id: experiment.id,
      experiment_name: experiment.name || experiment.id,
      variant_id: variant.id,
      variant_name: variant.name || variant.id,
      product_id: context.product.id,
      product_handle: context.product.handle,
      product_type: context.product.type,
      template: templateKeys().join("|"),
      source: "vaku_pdp_ab",
      timestamp: new Date().toISOString()
    };
    if (markers.pdp_ab_forced) {
      payload.pdp_ab_forced = 1;
    }
    var key;
    for (key in extra || {}) {
      if (Object.prototype.hasOwnProperty.call(extra, key)) {
        payload[key] = extra[key];
      }
    }

    if (window.VakuPdpExperimentInit) {
      window.VakuPdpExperimentInit.track(payload);
    } else {
      if (window.dataLayer && typeof window.dataLayer.push === "function") {
        window.dataLayer.push(payload);
      }
      if (typeof window.gtag === "function") {
        window.gtag("event", payload.event, payload);
      }
    }
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
      try {
        window.Shopify.analytics.publish(payload.event, payload);
      } catch (error) {}
    }
    try {
      document.dispatchEvent(new CustomEvent("vaku:pdp_ab:" + name, { detail: payload }));
    } catch (error) {}
  }

  function injectStyles() {
    if (document.getElementById("vaku-pdp-ab-styles")) {
      return;
    }
    var style = document.createElement("style");
    style.id = "vaku-pdp-ab-styles";
    style.textContent = [
      "@media(max-width:575px){.pdp-ab-gallery-thumbnails{width:100%;min-width:0;margin:0!important;padding:8px 12px 12px!important;box-sizing:border-box}.pdp-ab-gallery-thumbnails[hidden]{display:none!important}.pdp-ab-gallery-thumbnails #smallGallery{margin:0;padding:0}.pdp-ab-gallery-thumbnails .slick-list{margin:0!important}.pdp-ab-gallery-thumbnails .slick-slide{width:72px!important;padding:0 8px 0 0!important}.pdp-ab-gallery-thumbnails [role=button]{display:block;position:relative;width:64px;height:64px;padding:0;border:0;border-radius:0;background:transparent}.pdp-ab-gallery-thumbnails [role=button]:focus-visible{outline:2px solid #2459c4;outline-offset:-2px}.pdp-ab-gallery-thumbnails img{width:100%;height:100%;object-fit:contain}.pdp-ab-gallery-thumbnails-ready .tt-mobile-product-slider .slick-dots{display:none!important}}",
      ".pdp-ab-benefit-bar{margin:12px 0 10px;padding:10px 12px;border:1px solid #e5e7eb;background:#f8fafc;color:#111827;font-size:13px;font-weight:600;text-align:center;border-radius:6px;}",
      ".pdp-ab-trust-chips{display:flex;flex-wrap:wrap;gap:6px;margin:8px 0 12px;}",
      ".pdp-ab-trust-chip{padding:6px 8px;border:1px solid #e5e7eb;border-radius:4px;background:#fff;color:#374151;font-size:12px;line-height:1.2;}",
      ".pdp-ab-review-strip{margin:16px 0 0;}",
      ".pdp-ab-review-strip__head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:10px;}",
      ".pdp-ab-review-strip__eyebrow{display:inline-flex;align-items:center;gap:5px;color:#777;font-size:11px;letter-spacing:0;margin-bottom:3px;}",
      ".pdp-ab-review-strip__verified{display:inline-flex;align-items:center;justify-content:center;width:16px;height:16px;flex:0 0 16px;transform:translateY(-.5px);}",
      ".pdp-ab-review-strip__verified svg{display:block;width:16px;height:16px;overflow:visible;}",
      ".pdp-ab-review-strip__title{color:#111;font-size:14px;line-height:1.3;font-weight:600;margin:0;}",
      ".pdp-ab-review-strip__summary{font-size:12px;color:#777;white-space:nowrap;}",
      ".pdp-ab-review-strip__scroller{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x proximity;padding:2px 2px 8px;-webkit-overflow-scrolling:touch;}",
      ".pdp-ab-review-strip__scroller::-webkit-scrollbar{height:4px;}",
      ".pdp-ab-review-strip__scroller::-webkit-scrollbar-thumb{background:#d1d5db;border-radius:999px;}",
      ".pdp-ab-review-card{flex:0 0 252px;scroll-snap-align:start;border:1px solid #e5e7eb;background:#fff;border-radius:6px;padding:12px 12px 11px;box-shadow:0 1px 2px rgba(17,24,39,.04);}",
      ".pdp-ab-review-card__top{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:8px;}",
      ".pdp-ab-review-card__stars{color:#f5a400;font-size:13px;line-height:1;letter-spacing:1px;white-space:nowrap;}",
      ".pdp-ab-review-card__tag{font-size:11px;color:#555;background:#f5f5f5;border:1px solid #ececec;border-radius:4px;padding:3px 6px;white-space:nowrap;}",
      ".pdp-ab-review-card__quote{font-size:13px;line-height:1.45;color:#333;margin:0 0 9px;}",
      ".pdp-ab-review-card__meta{font-size:12px;color:#777;}",
      ".pdp-ab-sticky-buy-now-bar{display:none;}",
      "@media (max-width:767px){body.pdp-ab-sticky-buy-now .tt-fixed-product-wrapper{display:none!important}.pdp-ab-sticky-buy-now-bar{position:fixed;left:0;right:0;bottom:0;z-index:1001;display:flex;align-items:center;gap:8px;padding:10px 12px calc(10px + env(safe-area-inset-bottom));background:#fff;border-top:1px solid #e5e7eb;box-shadow:0 -3px 14px rgba(17,24,39,.14);transform:translateY(0);transition:transform .2s ease,visibility .2s ease}.pdp-ab-sticky-buy-now-bar.is-hidden{visibility:hidden;pointer-events:none;transform:translateY(110%)}.pdp-ab-sticky-buy-now-bar__image{display:flex;flex:0 0 42px;width:42px;height:42px;align-items:center;justify-content:center;overflow:hidden;border:1px solid #eee;border-radius:4px;background:#f7f7f7}.pdp-ab-sticky-buy-now-bar__image img{display:block;width:100%;height:100%;object-fit:cover}.pdp-ab-sticky-buy-now-bar__price{display:flex;flex:0 0 auto;min-width:82px;max-width:96px;flex-direction:column;align-items:flex-start;justify-content:center;gap:1px;line-height:1.15;white-space:nowrap}.pdp-ab-sticky-buy-now-bar__price-current{color:#f8353e;font-size:17px;font-weight:500}.pdp-ab-sticky-buy-now-bar__price-compare{color:#2879fe;font-size:13px;font-weight:500;text-decoration:line-through}.pdp-ab-sticky-buy-now-bar__button{flex:1 1 auto;min-width:0;min-height:50px;padding:0 10px;border:0;border-radius:6px;background:#ff9d00;color:#fff;font-size:15px;line-height:1.2;font-weight:400;overflow:hidden}.pdp-ab-sticky-buy-now-bar__button:disabled{opacity:.55;cursor:not-allowed}}",
      "@media (max-width:350px){.pdp-ab-sticky-buy-now-bar{gap:6px;padding-left:8px;padding-right:8px}.pdp-ab-sticky-buy-now-bar__image{flex-basis:38px;width:38px;height:38px}.pdp-ab-sticky-buy-now-bar__price{min-width:68px;max-width:74px}.pdp-ab-sticky-buy-now-bar__price-current{font-size:15px}.pdp-ab-sticky-buy-now-bar__price-compare{font-size:12px}.pdp-ab-sticky-buy-now-bar__button{padding-left:6px;padding-right:6px;font-size:13px}.pdp-ab-sticky-buy-now-bar__button .sr-pl-15{padding-left:5px!important}}",
      "@media(max-width:575px){body.pdp-ab-sticky-purchase{padding-bottom:calc(80px + env(safe-area-inset-bottom))}body.pdp-ab-sticky-purchase .tt-fixed-product-wrapper{display:none!important}.pdp-ab-sticky-purchase-bar:not(.pdp-ab-sticky-purchase-summary-bar) .pdp-ab-sticky-buy-now-bar__image,.pdp-ab-sticky-purchase-bar:not(.pdp-ab-sticky-purchase-summary-bar) .pdp-ab-sticky-buy-now-bar__price{display:none}.pdp-ab-sticky-purchase-bar .pdp-ab-sticky-buy-now-bar__button{flex:1 1 0;min-height:50px}.pdp-ab-sticky-purchase-bar .pdp-ab-sticky-buy-now-bar__add{background:#2879fe}body.modal-open .pdp-ab-sticky-purchase-bar{visibility:hidden;pointer-events:none}}",
      "@media(max-width:575px){.pdp-ab-sticky-purchase-summary-bar{gap:8px}.pdp-ab-sticky-purchase-summary-bar .pdp-ab-sticky-buy-now-bar__image{flex:0 0 38px;width:38px;height:38px}.pdp-ab-sticky-purchase-summary-bar .pdp-ab-sticky-buy-now-bar__image img{object-fit:contain}.pdp-ab-sticky-purchase-summary-bar .pdp-ab-sticky-buy-now-bar__price{min-width:76px;max-width:96px}.pdp-ab-sticky-purchase-summary-bar .pdp-ab-sticky-buy-now-bar__price-current{font-size:16px}.pdp-ab-sticky-purchase-summary-bar .pdp-ab-sticky-buy-now-bar__price-compare{font-size:11px}.pdp-ab-sticky-purchase-summary-bar .pdp-ab-sticky-buy-now-bar__button{padding:0 6px;font-size:13px;line-height:1.2}}",
      "@media(max-width:350px){.pdp-ab-sticky-purchase-summary-bar{gap:6px;padding-left:8px;padding-right:8px}.pdp-ab-sticky-purchase-summary-bar .pdp-ab-sticky-buy-now-bar__image{flex-basis:34px;width:34px;height:34px}.pdp-ab-sticky-purchase-summary-bar .pdp-ab-sticky-buy-now-bar__price{min-width:68px;max-width:80px}.pdp-ab-sticky-purchase-summary-bar .pdp-ab-sticky-buy-now-bar__price-current{font-size:14px}.pdp-ab-sticky-purchase-summary-bar .pdp-ab-sticky-buy-now-bar__button{font-size:12px}}",
      "@media (max-width:575px){.pdp-ab-review-strip{margin-top:14px}.pdp-ab-review-card{flex-basis:238px}.pdp-ab-review-strip__head{display:block}.pdp-ab-review-strip__summary{display:block;margin-top:4px;white-space:normal}}"
    ].join("");
    document.head.appendChild(style);
  }

  function insertNearForm(element, position) {
    var form = productForms()[0];
    if (!form || !form.parentNode) {
      purchaseRoot().appendChild(element);
      return;
    }
    if (position === "afterForm") {
      form.parentNode.insertBefore(element, form.nextSibling);
      return;
    }
    form.parentNode.insertBefore(element, form);
  }

  function applyCtaText(text) {
    if (!text) {
      return;
    }
    var buttons = purchaseRoot().querySelectorAll(".btn-addtocart");
    for (var i = 0; i < buttons.length; i += 1) {
      if ((" " + buttons[i].className + " ").indexOf(" disable ") !== -1) {
        continue;
      }
      buttons[i].setAttribute("data-pdp-ab-cta", "1");
      buttons[i].textContent = text;
    }
  }

  function applyBenefitBar(config) {
    if (!config || !config.text || document.getElementById("pdp-ab-benefit-bar")) {
      return;
    }
    var element = document.createElement("div");
    element.id = "pdp-ab-benefit-bar";
    element.className = "pdp-ab-benefit-bar";
    element.textContent = config.text;
    insertNearForm(element, config.position || "beforeForm");
  }

  function applyTrustChips(chips) {
    if (!chips || !chips.length || document.getElementById("pdp-ab-trust-chips")) {
      return;
    }
    var wrapper = document.createElement("div");
    wrapper.id = "pdp-ab-trust-chips";
    wrapper.className = "pdp-ab-trust-chips";
    for (var i = 0; i < chips.length; i += 1) {
      var chip = document.createElement("span");
      chip.className = "pdp-ab-trust-chip";
      chip.textContent = chips[i];
      wrapper.appendChild(chip);
    }
    insertNearForm(wrapper, "beforeForm");
  }

  // Mirrors the current PDP purchase state.
  function applyStickyBuyNow(config) {
    if (!config || viewportWidth() > (config.maxViewportWidth || 767)) {
      return;
    }

    var existing = document.getElementById("pdp-ab-sticky-buy-now-bar");
    if (existing) {
      if (typeof existing.pdpAbSync === "function") {
        existing.pdpAbSync();
      }
      return;
    }

    var wrapper = document.createElement("div");
    wrapper.id = "pdp-ab-sticky-buy-now-bar";
    wrapper.className = "pdp-ab-sticky-buy-now-bar is-hidden";
    if (config.addToCart) addClass(wrapper, "pdp-ab-sticky-purchase-bar");
    if (config.addToCart && config.showSummary) addClass(wrapper, "pdp-ab-sticky-purchase-summary-bar");
    wrapper.setAttribute("role", "region");
    wrapper.setAttribute("aria-label", "Quick purchase");

    var selectedImageFrame = document.createElement("div");
    selectedImageFrame.className = "pdp-ab-sticky-buy-now-bar__image";
    selectedImageFrame.hidden = true;
    wrapper.appendChild(selectedImageFrame);

    var selectedImage = document.createElement("img");
    selectedImage.alt = "Selected product variant";
    selectedImageFrame.appendChild(selectedImage);

    var price = document.createElement("div");
    price.className = "pdp-ab-sticky-buy-now-bar__price";
    wrapper.appendChild(price);

    var currentPrice = document.createElement("span");
    currentPrice.className = "pdp-ab-sticky-buy-now-bar__price-current";
    price.appendChild(currentPrice);

    var comparePrice = document.createElement("span");
    comparePrice.className = "pdp-ab-sticky-buy-now-bar__price-compare";
    comparePrice.hidden = true;
    price.appendChild(comparePrice);

    var addButton = null;
    var originalAddButton = function () {
      return purchaseRoot().querySelector(".btn-addtocart");
    };
    var unavailable = function (original) {
      return !original || original.disabled || original.classList.contains("disable") ||
        original.getAttribute("aria-disabled") === "true" ||
        Boolean(original.closest(".hide, .select_options")) ||
        window.getComputedStyle(original).pointerEvents === "none";
    };
    if (config.addToCart) {
      addButton = document.createElement("button");
      addButton.type = "button";
      addButton.className = "pdp-ab-sticky-buy-now-bar__button pdp-ab-sticky-buy-now-bar__add";
      addButton.textContent = "Add to Cart";
      addButton.addEventListener("click", function () {
        var original = originalAddButton();
        if (unavailable(original)) return;
        original.click();
        scheduleSync();
      });
      wrapper.appendChild(addButton);
    }

    var button = document.createElement("button");
    button.type = "button";
    button.className = "pdp-ab-sticky-buy-now-bar__button";
    button.textContent = config.ctaText || "Buy Now";
    button.setAttribute("aria-label", config.ctaText || "Buy Now");
    wrapper.appendChild(button);

    var syncQueued = false;
    var selectedImageSource = "";
    var setSelectedImage = function (source, variantId, variantTitle) {
      if (!source) {
        return;
      }
      if (window.Shopify && typeof window.Shopify.resizeImage === "function") {
        source = source.replace(
          /_(?:pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*|x\d+)(?=\.[a-z]+(?:\?|$))/i,
          ""
        );
        source = window.Shopify.resizeImage(source, "100x");
      }
      selectedImageSource = source;
      selectedImage.src = selectedImageSource;
      if (variantId) {
        selectedImage.setAttribute("data-variant-id", String(variantId));
      }
      selectedImage.alt = variantTitle ?
        "Selected variant: " + variantTitle : "Selected product variant";
      selectedImageFrame.hidden = false;
    };
    var sync = function () {
      syncQueued = false;
      var originalButton = stickyProductButton();
      var priceSource = purchaseRoot().querySelector("#price-block #animated-price") ||
        purchaseRoot().querySelector(".tt-price .sale-price, .tt-price .new-price");
      var comparePriceSource = purchaseRoot().querySelector("#price-block .old-price");
      var originalVisible = false;

      if ((!config.addToCart || config.showSummary) && !selectedImageSource) {
        var galleryImage = document.querySelector(".tt-mobile-product-slider .slick-current img") ||
          document.querySelector("#smallGallery .slick-current img") ||
          document.querySelector(".tt-fixed-product-wrapper .tt-img img");
        var variantInput = purchaseRoot().querySelector('input[name="id"]');
        if (galleryImage) {
          setSelectedImage(
            galleryImage.currentSrc || galleryImage.src,
            variantInput ? variantInput.value : "",
            ""
          );
        }
      }

      if (priceSource) {
        currentPrice.textContent = String(priceSource.textContent || "").replace(/\s+/g, " ").trim();
        if (window.getComputedStyle) {
          var currentPriceStyle = window.getComputedStyle(priceSource);
          currentPrice.style.color = currentPriceStyle.color;
          currentPrice.style.fontWeight = currentPriceStyle.fontWeight;
        }
      }

      if (comparePriceSource && String(comparePriceSource.textContent || "").trim()) {
        comparePrice.textContent = String(comparePriceSource.textContent || "").replace(/\s+/g, " ").trim();
        comparePrice.hidden = false;
        if (window.getComputedStyle) {
          var comparePriceStyle = window.getComputedStyle(comparePriceSource);
          comparePrice.style.color = comparePriceStyle.color;
          comparePrice.style.fontWeight = comparePriceStyle.fontWeight;
          comparePrice.style.textDecoration = comparePriceStyle.textDecoration;
        }
      } else {
        comparePrice.textContent = "";
        comparePrice.hidden = true;
      }

      if (originalButton) {
        var rect = originalButton.getBoundingClientRect();
        originalVisible = originalButton.offsetParent !== null &&
          rect.bottom > 0 && rect.top < window.innerHeight;
        button.disabled = config.addToCart ? unavailable(originalButton) : Boolean(originalButton.disabled);
        if (!config.addToCart && originalButton.innerHTML && button.innerHTML !== originalButton.innerHTML) {
          button.innerHTML = originalButton.innerHTML;
        }
        if (window.getComputedStyle) {
          var originalStyle = window.getComputedStyle(originalButton);
          button.style.backgroundColor = originalStyle.backgroundColor;
          button.style.color = originalStyle.color;
          button.style.borderRadius = originalStyle.borderRadius;
          button.style.fontFamily = originalStyle.fontFamily;
          button.style.fontSize = originalStyle.fontSize;
          button.style.fontWeight = originalStyle.fontWeight;
          button.style.height = originalStyle.height;
        }
      } else {
        button.disabled = true;
      }

      var originalAdd = addButton && originalAddButton();
      if (addButton) {
        addButton.disabled = unavailable(originalAdd);
        // A sold-out/selection-disabled Add to Cart also blocks the checkout proxy.
        button.disabled = button.disabled || addButton.disabled;
        if (originalAdd) {
          var addRect = originalAdd.getBoundingClientRect();
          originalVisible = originalVisible || (originalAdd.offsetParent !== null &&
            addRect.bottom > 0 && addRect.top < window.innerHeight);
          addButton.style.backgroundColor = window.getComputedStyle(originalAdd).backgroundColor;
          addButton.style.color = window.getComputedStyle(originalAdd).color;
        }
      }
      if (!originalButton || (addButton && !originalAdd) || originalVisible ||
          viewportWidth() > (config.maxViewportWidth || 767)) {
        addClass(wrapper, "is-hidden");
      } else {
        wrapper.classList.remove("is-hidden");
      }
    };
    var scheduleSync = function () {
      if (syncQueued) {
        return;
      }
      syncQueued = true;
      window.requestAnimationFrame(sync);
    };

    button.addEventListener("click", function () {
      var originalButton = stickyProductButton();
      if (!originalButton || originalButton.disabled ||
          (config.addToCart && (unavailable(originalButton) || unavailable(originalAddButton())))) {
        return;
      }
      originalButton.click();
      scheduleSync();
    });

    wrapper.pdpAbSync = scheduleSync;
    document.body.appendChild(wrapper);
    window.addEventListener("scroll", scheduleSync, { passive: true });
    window.addEventListener("resize", scheduleSync);
    document.addEventListener("variant:changed", function (event) {
      if (!event.detail || !event.detail.variant) {
        return;
      }
      var featuredMedia = event.detail.variant.featured_media ||
        event.detail.variant.featured_image;
      if (config.showSummary) {
        // Shopify product JSON media stores its source in preview_image.
        var summaryMedia = featuredMedia && (featuredMedia.preview_image || featuredMedia);
        featuredMedia = summaryMedia && summaryMedia.src ? summaryMedia :
          event.detail.variant.featured_image;
      }
      selectedImageSource = "";
      if ((!config.addToCart || config.showSummary) && featuredMedia && featuredMedia.src) {
        setSelectedImage(
          featuredMedia.src,
          event.detail.variant.id,
          event.detail.variant.title
        );
      }
      scheduleSync();
    });

    if (window.MutationObserver) {
      new MutationObserver(scheduleSync).observe(purchaseRoot(), {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }
    scheduleSync();
  }

  function createVerifiedBadge() {
    var badge = document.createElement("span");
    badge.className = "pdp-ab-review-strip__verified";
    badge.setAttribute("aria-label", "Verified");
    badge.setAttribute("role", "img");
    badge.innerHTML = [
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">',
      '<path fill="#24A8F2" d="M10.31 3.52 C11.12 2.38 11.38 1.15 12 1.15 C12.62 1.15 12.88 2.38 13.69 3.52 C14.87 2.78 15.58 1.74 16.15 1.98 C16.72 2.21 16.49 3.45 16.81 4.81 C18.18 4.58 19.23 3.89 19.67 4.33 C20.11 4.77 19.42 5.82 19.19 7.19 C20.55 7.51 21.79 7.28 22.02 7.85 C22.26 8.42 21.22 9.13 20.48 10.31 C21.62 11.12 22.85 11.38 22.85 12 C22.85 12.62 21.62 12.88 20.48 13.69 C21.22 14.87 22.26 15.58 22.02 16.15 C21.79 16.72 20.55 16.49 19.19 16.81 C19.42 18.18 20.11 19.23 19.67 19.67 C19.23 20.11 18.18 19.42 16.81 19.19 C16.49 20.55 16.72 21.79 16.15 22.02 C15.58 22.26 14.87 21.22 13.69 20.48 C12.88 21.62 12.62 22.85 12 22.85 C11.38 22.85 11.12 21.62 10.31 20.48 C9.13 21.22 8.42 22.26 7.85 22.02 C7.28 21.79 7.51 20.55 7.19 19.19 C5.82 19.42 4.77 20.11 4.33 19.67 C3.89 19.23 4.58 18.18 4.81 16.81 C3.45 16.49 2.21 16.72 1.98 16.15 C1.74 15.58 2.78 14.87 3.52 13.69 C2.38 12.88 1.15 12.62 1.15 12 C1.15 11.38 2.38 11.12 3.52 10.31 C2.78 9.13 1.74 8.42 1.98 7.85 C2.21 7.28 3.45 7.51 4.81 7.19 C4.58 5.82 3.89 4.77 4.33 4.33 C4.77 3.89 5.82 4.58 7.19 4.81 C7.51 3.45 7.28 2.21 7.85 1.98 C8.42 1.74 9.13 2.78 10.31 3.52 Z"/>',
      '<path d="M7.2 12.25 10.35 15.4 16.95 8.75" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/>',
      '</svg>'
    ].join("");
    return badge;
  }

  function applyReviewStrip(config) {
    var reviews = arrayValue(config && config.reviews);
    if (!config || !reviews.length || document.getElementById("pdp-ab-review-strip")) {
      return;
    }

    var wrapper = document.createElement("div");
    wrapper.id = "pdp-ab-review-strip";
    wrapper.className = "tt-wrapper pdp-ab-review-strip";

    var head = document.createElement("div");
    head.className = "pdp-ab-review-strip__head";

    var titleBlock = document.createElement("div");
    if (config.eyebrow) {
      var eyebrow = document.createElement("div");
      eyebrow.className = "pdp-ab-review-strip__eyebrow";
      if (config.verifiedBadge) {
        eyebrow.appendChild(createVerifiedBadge());
      }
      eyebrow.appendChild(document.createTextNode(config.eyebrow));
      titleBlock.appendChild(eyebrow);
    }
    if (config.heading) {
      var heading = document.createElement("div");
      heading.className = "pdp-ab-review-strip__title";
      heading.textContent = config.heading;
      titleBlock.appendChild(heading);
    }
    head.appendChild(titleBlock);

    if (config.summary) {
      var summary = document.createElement("div");
      summary.className = "pdp-ab-review-strip__summary";
      summary.textContent = config.summary;
      head.appendChild(summary);
    }
    wrapper.appendChild(head);

    var scroller = document.createElement("div");
    scroller.className = "pdp-ab-review-strip__scroller";
    for (var i = 0; i < reviews.length; i += 1) {
      var item = reviews[i] || {};
      var card = document.createElement("article");
      card.className = "pdp-ab-review-card";

      var top = document.createElement("div");
      top.className = "pdp-ab-review-card__top";

      var stars = document.createElement("div");
      stars.className = "pdp-ab-review-card__stars";
      stars.setAttribute("aria-label", item.rating ? item.rating + " rating" : "5 star rating");
      var rating = parseFloat(item.rating);
      var filledStars = isNaN(rating) ? 5 : Math.max(0, Math.min(5, Math.round(rating)));
      stars.textContent = "★★★★★".slice(0, filledStars) + "☆☆☆☆☆".slice(filledStars);
      top.appendChild(stars);

      if (item.tag) {
        var tag = document.createElement("div");
        tag.className = "pdp-ab-review-card__tag";
        tag.textContent = item.tag;
        top.appendChild(tag);
      }
      card.appendChild(top);

      var quote = document.createElement("p");
      quote.className = "pdp-ab-review-card__quote";
      quote.textContent = item.quote || "";
      card.appendChild(quote);

      if (item.author || item.detail) {
        var meta = document.createElement("div");
        meta.className = "pdp-ab-review-card__meta";
        meta.textContent = [item.author, item.detail].filter(Boolean).join(" - ");
        card.appendChild(meta);
      }

      scroller.appendChild(card);
    }
    wrapper.appendChild(scroller);
    insertNearForm(wrapper, config.position || "afterForm");
  }

  function applyGalleryThumbnails(root) {
    // Reuse the native desktop DOM, Slick instance, media icons and lazy sources.
    var nav = root.querySelector("#smallGallery"), slider = root.querySelector(".tt-mobile-product-slider");
    if (!nav || !slider || root.galleryThumbnailsApplied) return;
    root.galleryThumbnailsApplied = true;
    var strip = nav.parentNode, home = document.createComment("native thumbnail position");
    strip.parentNode.insertBefore(home, strip);
    var mobile = window.matchMedia("(max-width:575px)"), connected = false, timeout;
    function id(item) {
      var link = item.querySelector("[data-item-type]");
      return link ? link.getAttribute("data-target") : "legacy-video";
    }
    function target(link) { return link.hasAttribute("data-item-type") ? link.getAttribute("data-target") : "legacy-video"; }
    function connect() {
      // Both native init events fire inside Slick's constructor, before assignment.
      if (connected || !window.jQuery || !slider.slick || !nav.slick || !slider.slick.$slides || !nav.slick.$slides) return;
      connected = true;
      clearTimeout(timeout);
      window.removeEventListener("mobile-slider-initialized", deferConnect);
      window.removeEventListener("desktop-slider-initialized", deferConnect);
      var $nav = window.jQuery(nav), $slider = window.jQuery(slider);
      var desktop = Object.assign({}, nav.slick.originalSettings), mainInfinite = slider.slick.options.infinite;
      var mobileOptions = {vertical:false, verticalSwiping:false, variableWidth:true, slidesToShow:1, arrows:false, infinite:true,
        swipeToSlide:true, touchThreshold:12, speed:220, cssEase:"ease-out"};
      var links = (nav.slick.$slidesCache || nav.slick.$slides).find("[data-item-type],.video-link-product").toArray();
      var images = links.map(function (link) { var img = link.querySelector("img"); return {img:img, srcset:img.srcset, decoding:img.decoding, priority:img.fetchPriority}; });
      function markSelection() {
        var main = slider.slick;
        if (!mobile.matches || !main || main.unslicked) return;
        var selectedId = main.$slides.eq(main.currentSlide).attr("data-pdp-ab-media-id");
        nav.querySelectorAll("[data-item-type],.video-link-product").forEach(function (link) {
          var selected = target(link) === selectedId, clone = Boolean(link.closest(".slick-cloned"));
          link.classList.toggle("zoomGalleryActive", selected);
          link.setAttribute("role", "button");
          link.setAttribute("aria-label", "View " + (link.querySelector("img").alt || link.getAttribute("data-item-type") || "video"));
          link.setAttribute("aria-pressed", String(selected && !clone));
          link.tabIndex = selected && !clone ? 0 : -1;
        });
      }
      function sync() {
        var main = slider.slick;
        if (!mobile.matches || !main || main.unslicked) { root.classList.remove("pdp-ab-gallery-thumbnails-ready"); return; }
        var ids = main.$slides.toArray().map(function (slide) { return slide.getAttribute("data-pdp-ab-media-id"); });
        if (nav.slick.$slides.toArray().map(id).join() !== ids.join()) {
          $nav.slick("slickUnfilter").slick("slickFilter", function (_, slide) { return ids.indexOf(id(slide)) >= 0; });
        }
        markSelection();
        strip.hidden = ids.length < 2;
        root.classList.toggle("pdp-ab-gallery-thumbnails-ready", !strip.hidden);
        $nav.slick("slickGoTo", main.currentSlide, true);
      }
      function mount() {
        strip.classList.toggle("pdp-ab-gallery-thumbnails", mobile.matches);
        strip.hidden = false;
        images.forEach(function (image) {
          image.img.srcset = mobile.matches ? image.srcset.replace("_300x.", "_160x.") : image.srcset;
          image.img.decoding = mobile.matches ? "async" : image.decoding;
          image.img.fetchPriority = mobile.matches ? "low" : image.priority;
        });
        if (mobile.matches) slider.after(strip);
        else { home.after(strip); links.forEach(function (link) { ["role", "aria-label", "aria-pressed"].forEach(function (attr) { link.removeAttribute(attr); }); }); }
        // A real breakpoint array also clears Slick's cached desktop breakpoints.
        $nav.slick("slickSetOption", mobile.matches ? Object.assign({}, desktop, mobileOptions, {responsive:[{breakpoint:576, settings:mobileOptions}]}) : desktop, true);
        var infinite = mobile.matches ? true : mainInfinite;
        if (slider.slick.options.infinite !== infinite) $slider.slick("slickSetOption", "infinite", infinite, true);
        sync();
        if (!mobile.matches) {
          var selected = nav.querySelector(".zoomGalleryActive");
          if (selected) selected.click();
        }
      }
      // Capture only mobile treatment clicks; prevent hidden desktop zoom/video work.
      strip.addEventListener("click", function (event) {
        var link = event.target.closest("[data-item-type],.video-link-product");
        if (!mobile.matches || !link || slider.slick.unslicked) return;
        event.preventDefault(); event.stopImmediatePropagation();
        // Capture runs before Slick's click guard; do not turn a drag into selection.
        if (event.detail && nav.slick.shouldClick === false) return;
        var index = slider.slick.$slides.toArray().findIndex(function (slide) { return slide.getAttribute("data-pdp-ab-media-id") === target(link); });
        if (index >= 0) $slider.slick("slickGoTo", index);
      }, true);
      strip.addEventListener("keydown", function (event) {
        if (!mobile.matches) return;
        var link = event.target.closest("[data-item-type],.video-link-product");
        if (!link) return;
        var visible = nav.slick.$slides.find("[data-item-type],.video-link-product").toArray(), next;
        var index = visible.findIndex(function (item) { return target(item) === target(link); });
        if (index < 0) return;
        if (event.key === "ArrowRight") next = (index + 1) % visible.length;
        else if (event.key === "ArrowLeft") next = (index + visible.length - 1) % visible.length;
        else if (event.key === "Home") next = 0;
        else if (event.key === "End") next = visible.length - 1;
        else if (event.key === " " || event.key === "Enter") next = index;
        else return;
        event.preventDefault(); event.stopImmediatePropagation();
        visible[next].click(); visible[next].focus();
      }, true);
      $slider.on("afterChange.pdpAbThumbnails reInit.pdpAbThumbnails destroy.pdpAbThumbnails", sync);
      $nav.on("afterChange.pdpAbThumbnails reInit.pdpAbThumbnails", markSelection);
      mobile.addEventListener("change", mount);
      mount();
    }
    function deferConnect() { window.setTimeout(connect, 0); }
    window.addEventListener("mobile-slider-initialized", deferConnect);
    window.addEventListener("desktop-slider-initialized", deferConnect);
    timeout = window.setTimeout(function () {
      window.removeEventListener("mobile-slider-initialized", deferConnect);
      window.removeEventListener("desktop-slider-initialized", deferConnect);
    }, 30000);
    deferConnect();
  }

  function applyVariant(experiment, variant) {
    var changes = variant.changes || {};
    var root = productRoot();

    root.setAttribute("data-pdp-ab-experiment", experiment.id);
    root.setAttribute("data-pdp-ab-variant", variant.id);
    if (document.body) {
      addClass(document.body, "pdp-ab-running pdp-ab-" + variant.id);
      addClass(document.body, changes.bodyClass);
    }

    injectStyles();
    applyBenefitBar(changes.benefitBar);
    applyTrustChips(arrayValue(changes.trustChips));
    applyReviewStrip(changes.reviewStrip);
    applyStickyBuyNow(changes.stickyBuyNow);
    applyCtaText(changes.ctaText);
    if (changes.galleryThumbnails) applyGalleryThumbnails(root);
  }

  function bindMeasurement(experiment, variant) {
    var root = purchaseRoot();
    var reapply = function () {
      applyVariant(experiment, variant);
    };

    root.addEventListener("click", function (event) {
      var target = event.target;
      while (target && target !== root) {
        if ((" " + target.className + " ").indexOf(" btn-addtocart ") !== -1) {
          if (target.getAttribute("data-pdp-ab-attribution-ready") === "1") {
            target.removeAttribute("data-pdp-ab-attribution-ready");
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();

          if (target.getAttribute("data-pdp-ab-attribution-pending") === "1") {
            return;
          }

          target.setAttribute("data-pdp-ab-attribution-pending", "1");
          emit("cta_click", experiment, variant);
          emit("add_to_cart_intent", experiment, variant);
          window.setTimeout(reapply, 250);
          updateCartAttributes(experiment, variant, function () {
            target.removeAttribute("data-pdp-ab-attribution-pending");
            target.setAttribute("data-pdp-ab-attribution-ready", "1");
            target.click();
          });
          return;
        }
        target = target.parentNode;
      }
    }, true);

    var forms = productForms();
    for (var i = 0; i < forms.length; i += 1) {
      // Persist attribution before cart creation.
      forms[i].addEventListener("submit", function (event) {
        var form = event.currentTarget;
        if (form.getAttribute("data-pdp-ab-attribution-ready") === "1") {
          form.removeAttribute("data-pdp-ab-attribution-ready");
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        if (form.getAttribute("data-pdp-ab-attribution-pending") === "1") {
          return;
        }
        form.setAttribute("data-pdp-ab-attribution-pending", "1");
        var submitter = event.submitter || null;
        emit("add_to_cart_intent", experiment, variant);
        updateCartAttributes(experiment, variant, function () {
          form.removeAttribute("data-pdp-ab-attribution-pending");
          resumeProductForm(form, submitter);
        });
      }, true);
      forms[i].addEventListener("change", function () {
        window.setTimeout(reapply, 150);
        window.setTimeout(reapply, 500);
      }, true);
    }
  }

  function boot(registry) {
    onReady(function () {
      var init = window.VakuPdpExperimentInit;
      // Never relabel a page after a genuine initialization failure/fallback.
      if (init && init.status !== "pending") return;
      var coupon = window.VakuCouponAutoApply;
      var experiment = activeExperiment(registry);
      if (!experiment) {
        bindFastrrCartCarryover(registry);
        if (init) init.finish(registry && registry.activeExperimentId ? "ineligible" : "inactive");
        if (coupon) coupon.start("viewport");
        return;
      }
      // Do not assign/expose visitors after the native timing fallback has begun.
      if (experiment.scope && experiment.scope.requiresCouponCode && (!coupon || coupon.started)) {
        if (init) init.fail(coupon ? "coupon_already_started" : "coupon_controller_missing");
        return;
      }
      var variant = assignedVariant(experiment);
      if (!variant) {
        if (init) init.finish("ineligible", experiment);
        if (coupon) coupon.start("viewport");
        return;
      }

      applyVariant(experiment, variant);
      bindMeasurement(experiment, variant);
      bindFastrrBuyNow(experiment, variant);
      bindNativeBuyNow(experiment, variant);
      emit("view", experiment, variant);
      if (init) init.finish("assigned", experiment, variant);
      if (queryParam("pdp_ab_debug") === "1" || context.debug) {
        window.VakuPdpExperiment = {
          experiment: experiment,
          variant: variant,
          context: context
        };
      }
      if (coupon) coupon.start((variant.changes || {}).couponAutoApply || "viewport");
    });
  }

  if (context.registry) {
    // Inline configuration removes the registry-network versus coupon-fallback race.
    boot(context.registry);
  } else if (context.initializationVersion && window.VakuPdpExperimentInit) {
    window.VakuPdpExperimentInit.fail("inline_registry_missing");
  } else {
    // Compatibility while the loader and harness are deployed independently.
    loadRegistry(context.registryUrl, function (error, registry) {
      boot(error ? null : registry);
    });
  }
}());
